/** Английский контент страницы Guidelines for Authors — общий для сида и fallback на фронте. */

export const guidelinesAuthorsEn = {
  pageTitle: 'Guidelines for Authors',
  cards: {
    presentations: {
      title: 'Author Presentations',
      subtitle: '(Conference Participation)',
      item1:
        'If your article is accepted for presentation at the associated conference, at least one author must present the work in person.',
      item2: "Failure to present may result in the article's exclusion from the journal or proceedings.",
      item3: '',
    },
    submissionLimits: {
      title: 'Submission Limits',
      subtitle: '',
      item1:
        "To ensure fairness and maintain journal quality, authors are limited to a maximum of two (2) submissions (including co-authorship) per publication cycle or per year, depending on the journal's policy and the specific issue being reviewed.",
      item2: 'No more than 3 authors from an institution are allowed.',
      item3: 'The maximum amount of authors is 10.',
    },
    language: {
      title: 'Language',
      subtitle: '',
      item1: 'All submissions must be written in clear and concise English.',
      item2: '',
      item3: '',
    },
    originalityScope: {
      title: 'Originality and Scope',
      subtitle: '',
      item1:
        'AdvAES publishes original research that has not been previously published or is currently under consideration elsewhere.',
      item2: 'Compiled research articles should present comprehensive analyses and well-documented results.',
      item3: '',
    },
  },
  expandable: {
    reviewCriteria: {
      title: 'Review Criteria:',
      intro: ' Articles will be evaluated based on the following criteria:',
      bullet1: "Relevance to the journal's scope.",
      bullet2: 'Clarity and well-defined objectives.',
      bullet3: 'Writing quality and readability.',
      bullet4: 'Potential impact and audience appeal.',
      bullet5: 'Logical organization and flow.',
      bullet6: 'Appropriate literature review.',
      bullet7: 'Sound methodology and analysis (where applicable).',
      bullet8: 'Evidence supporting arguments.',
      bullet9: 'Contribution to the field.',
      bullet10: '',
      body: '',
    },
    reviewProcess: {
      title: 'Review Process:',
      intro: 'Review Process:',
      bullet1: 'Initial screening by the editorial team',
      bullet2: 'Assignment to expert reviewers in the field',
      bullet3: 'Double-blind peer review evaluation',
      bullet4: 'Editorial decision based on reviewer recommendations',
      bullet5: 'Author notification and feedback provision',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body: '',
    },
    lengthRequirements: {
      title: 'Length Requirements:',
      intro: 'Manuscripts should adhere to the following length guidelines:',
      bullet1: 'Full research articles: 6-10 pages',
      bullet2: 'Abstract: 150-250 words',
      bullet3: 'Keywords: 4-6 terms',
      bullet4: 'References: Minimum 15, maximum 50',
      bullet5: '',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body: '',
    },
    anonymization: {
      title: 'Anonymization for Review:',
      intro: 'To maintain the integrity of the double-blind review process:',
      bullet1: 'Remove all author names and affiliations from the manuscript',
      bullet2: 'Avoid self-identifying references in the text',
      bullet3: 'Remove acknowledgments that might reveal identity',
      bullet4: 'Ensure document properties do not contain author information',
      bullet5: '',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body: '',
    },
    publicationFees: {
      title: 'Publication Fees:',
      intro: 'Publication fees for accepted manuscripts:',
      bullet1: 'Conference participation and publication: free',
      bullet2: 'Publication only (remote): free',
      bullet3: 'Fees cover editorial processing and open access publication',
      bullet4: '',
      bullet5: '',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body: '',
    },
    journalPublication: {
      title: 'Journal Publication:',
      intro: 'Publication timeline and process:',
      bullet1: 'Accepted manuscripts are published in the next available issue',
      bullet2: 'Articles are published online first with DOI assignment',
      bullet3: 'Final publication occurs after the conference proceedings',
      bullet4: 'All articles are openly accessible upon publication',
      bullet5: '',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body: '',
    },
    copyright: {
      title: 'Copyright and Open Access:',
      intro: 'Copyright and licensing information:',
      bullet1:
        'Published under Creative Commons Attribution-ShareAlike 4.0 International License (CC BY-SA 4.0)',
      bullet2: 'Authors retain copyright of their work',
      bullet3: 'Articles are freely available for reading, downloading, and sharing',
      bullet4: 'Proper attribution must be provided when reusing content',
      bullet5: '',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body: '',
    },
    warranties: {
      title: 'Warranties:',
      intro: 'By submitting a manuscript, authors warrant that:',
      bullet1: 'The work is original and has not been published elsewhere',
      bullet2: 'All co-authors have approved the submission',
      bullet3: 'Necessary permissions have been obtained for any copyrighted material',
      bullet4: 'The research complies with ethical standards',
      bullet5: 'All data presented is accurate and authentic',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body: '',
    },
    selfCitation: {
      title: 'Self-Citation Policy:',
      intro: '',
      bullet1: '',
      bullet2: '',
      bullet3: '',
      bullet4: '',
      bullet5: '',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body:
        'Authors are permitted to include references to their own previously published works; however, the number of such self-citations should not exceed 15% of the total number of references used in the manuscript.',
    },
    originalityCheck: {
      title: 'Originality Check:',
      intro: '',
      bullet1: '',
      bullet2: '',
      bullet3: '',
      bullet4: '',
      bullet5: '',
      bullet6: '',
      bullet7: '',
      bullet8: '',
      bullet9: '',
      bullet10: '',
      body:
        'All submitted manuscripts undergo a plagiarism check using the PlagAware system. A similarity index above 20% may result in rejection of the paper, although each case is evaluated individually. Proper citation and adherence to the principles of academic integrity are mandatory.',
    },
  },
};
